/**
 * 公共
 */
export default {
	install(Vue) {

		/**
		 * 绑定事件集
		 * @param {EventTarget} target 目标事件对象
		 */
		Vue.prototype.$bindEvents = function (target) {
			Object.entries(this.$listeners).reduce((p, [k, v]) => {
				return k == 'input' && 'input' in this.$refs || `on${k}` in p && p.addEventListener(k, v), p;
			}, target);
		}

		/**
		 * 派遣事件
		 * @param {string} type 事件类型
		 * @param {Object} option 事件参数
		 */
		EventTarget.prototype.emit = function (type, option) {
			let event = Object.assign(document.createEvent("Events"), option);
			event.initEvent(type), this.dispatchEvent(event);
		}

	}
}


// WEBPACK FOOTER //
// ./src/vue-ext/script/common.js